import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { useApp } from "../../hooks/useApp";
import CircularProgress from "@mui/material/CircularProgress";
import { useAnon } from "../../hooks/useAnon";
import { useSegment } from "../../hooks/useSegment";
import MegaFactoryContent from "../../components/MegaFactoryContent";
import FactoryContent from "../../components/FactoryContent";
import Videoplayer from "../../components/Videoplayer";

const HANNOVER_ASSET_ID = "WYUvDaOnQYgoSKsx0Gnd";

export default function HannoverDirect() {
  const [activeAsset, setActiveAsset] = useState(null);
  const [loaded, setLoaded] = useState({
    loading: null,
    value: 0,
    fail: false,
  });
  const { user } = useAuth();
  const { activeVideo, vtecAssetsUnsorted: vtecAssets } = useApp();
  const { trackDirectEvent } = useSegment();
  const { loginAnon } = useAnon();

  useEffect(() => {
    if (!vtecAssets) return;

    const foundAsset = vtecAssets.find(
      (vtecAsset) => vtecAsset.id === HANNOVER_ASSET_ID
    );
    if (!foundAsset) {
      setLoaded({ loading: "Asset not found", fail: true });
      return;
    }

    if (foundAsset.Type !== "factory" && foundAsset.Type !== "megafactory") {
      setLoaded({
        loading: "Only works for factories and megafactories",
        fail: true,
      });
      return;
    }

    setActiveAsset(foundAsset);
    setLoaded({ loading: "complete", value: 100, fail: false });

    if (user) {
      trackDirectEvent("asset opened", foundAsset, "Tulip");
    } else {
      loginAnon(null).then(() => {
        trackDirectEvent("asset opened", foundAsset, "Tulip");
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vtecAssets]);

  return (
    <Box
      className="standardGradient"
      style={{ width: "100%", backgroundColor: "grey", height: "100vh" }}
    >
      {loaded.loading !== "complete" ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
          }}
        >
          <CircularProgress
            color={loaded.fail ? "error" : "success"}
            size={100}
            thickness={5}
          />
          <Typography fontSize={"large"} color={"#fff"} marginTop={4}>
            {loaded.loading}
          </Typography>
        </Box>
      ) : (
        <>
          {activeAsset && activeAsset.Type === "factory" ? (
            <FactoryContent
              activeFactory={activeAsset}
              isModal={false}
              isFactoryDirect={false}
            />
          ) : (
            <MegaFactoryContent
              activeMegaFactory={activeAsset}
              isModal={false}
              isFactoryDirect={false}
            />
          )}
          {activeVideo && <Videoplayer />}
        </>
      )}
    </Box>
  );
}
